export default {"src":"/_next/static/media/card.3336c699.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};